var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invite-pipeline"},_vm._l((_vm.pipelineStages),function(item,index){return _c('div',{key:index + item.iconName,staticClass:"invite-item",class:{ 'middle-item': index === 1 }},[_c('div',{staticClass:"icon",class:[item.iconName]}),_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(item.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }